var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.369,
    height: 30.026,
    viewBox: "0 0 128.369 30.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LOGO",
    transform: "translate(-164.87 -499.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(164.87 499.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M190.94,499.14l9.384,30.026H204.7l-9.38-30.026Z",
    transform: "translate(-181.361 -499.14)",
    fill: "#2682ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M177.88,512.76l6.672,21.267h4.354l-6.661-21.267Z",
    transform: "translate(-173.1 -507.756)",
    fill: "#2682ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M164.87,526.38l3.913,12.511h4.336L169.2,526.38Z",
    transform: "translate(-164.87 -516.371)",
    fill: "#2682ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M257.866,528.53,253.1,540.251h1.539l1.2-3.1h5.677l1.216,3.1h1.749l-4.946-11.721ZM256.26,536c.779-2.043,1.477-4.167,2.352-6.162L261.044,536Z",
    transform: "translate(-55.812 -18.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M299,534.116a2.6,2.6,0,0,0,2.19-2.66c0-2.124-1.9-2.936-3.729-2.936H293.33v11.721h3.939c2.157,0,4.394-.617,4.394-3.259C301.663,535.233,300.609,534.41,299,534.116Zm-4.181-4.394h2.5c1.231,0,2.3.5,2.3,1.863,0,1.539-1.168,2.043-2.532,2.043h-2.271v-3.906Zm2.01,9.325h-2.01v-4.3h2.484c1.525,0,2.77.437,2.77,2.172C300.076,538.885,298.389,539.047,296.832,539.047Z",
    transform: "translate(-81.26 -18.585)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M330.612,533.417a15.621,15.621,0,0,1-2.285-.845,1.653,1.653,0,0,1-1.036-1.444c0-1.4,1.345-1.944,2.561-1.944s2.2.456,2.333,1.815h1.54c-.033-2.252-1.929-2.969-3.858-2.969-2.028,0-4.119.908-4.119,3.226,0,2.028,1.672,2.66,3.34,3.178a12.283,12.283,0,0,1,2.285.827,1.741,1.741,0,0,1,1.036,1.573c0,1.492-1.492,2.076-2.789,2.076-1.378,0-2.546-.647-2.627-2.138l-1.573.015c.162,2.4,1.962,3.307,4.152,3.307,2.138,0,4.394-.974,4.394-3.435C333.966,534.552,332.28,533.968,330.612,533.417Z",
    transform: "translate(-101.559 -18.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M362.972,527.86c-3.615,0-5.3,2.789-5.3,6.1,0,3.373,1.606,6.063,5.287,6.063,3.7,0,5.3-2.77,5.3-6.143C368.259,530.458,366.683,527.86,362.972,527.86Zm-.018,10.964c-2.77,0-3.678-2.531-3.678-4.9s.941-4.846,3.678-4.846c2.822,0,3.7,2.432,3.7,4.846C366.654,536.307,365.728,538.824,362.954,538.824Z",
    transform: "translate(-121.96 -18.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M398.975,528.53H397.45v11.721h7.282v-1.183h-5.758Z",
    transform: "translate(-147.124 -18.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M433.353,535.5a5.191,5.191,0,0,1-.29,2.058,2.959,2.959,0,0,1-2.855,1.687,3.05,3.05,0,0,1-2.642-1.264,4.387,4.387,0,0,1-.485-2.447v-7H425.49v7.216c0,3.211,1.591,4.718,4.7,4.718,3.017,0,4.7-1.686,4.7-4.685v-7.246h-1.54V535.5Z",
    transform: "translate(-164.861 -18.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10",
    "data-name": "Caminho 10",
    d: "M460.16,529.728h3.729v10.523h1.51V529.728h3.744v-1.2H460.16Z",
    transform: "translate(-186.792 -18.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M495.367,539.068v-4.28h5.515V533.6h-5.515v-3.891h5.758V528.53H493.86v11.721h7.488v-1.183Z",
    transform: "translate(-208.11 -18.591)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e00e0717ae8227429c4202b913ae1de.svg";
export { ForwardRef as ReactComponent };